import $ from 'jquery';
import Scrollbar from 'smooth-scrollbar';

$(document).ready(function() {
    const organizationsScrollbarElement = document.querySelector('#organizationsScrollbar');
    let scrollbar = null;
    if ( organizationsScrollbarElement ) {
        scrollbar = Scrollbar.init(document.querySelector('#organizationsScrollbar'), {
            alwaysShowTracks: true
        });
    }


   $(document).on('mouseenter', '[data-province]', function(e) {
       const province = $(this).data('province');
       $('[data-province="' + province + '"]').addClass('active');
       if ( $(this).parents('.organizationsMap').length && scrollbar ) {
           scrollbar.scrollIntoView($('.organizationTeaser[data-province="' + province + '"]')[0]);
       }
   });

   $(document).on('mouseleave', '[data-province]', function(e) {
       const province = $(this).data('province');
       $('[data-province="' + province + '"]').removeClass('active');
   });


    $(document).on('click', '.organizationsMap [data-province]', function(e) {
        e.preventDefault();
        const province = $(this).data('province');
        $('.organizationTeaser[data-province="' + province + '"]')[0].click();
    })
});